"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var MediaManagerImage_1 = __importDefault(require("@sportnet/ui/lib/MediaManagerImage"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var polished_1 = require("polished");

var utilities_1 = require("../../utilities");

var linkClass = 'widget-television-aside-link';
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: ", ";\n\n  .", " {\n    display: block;\n    text-decoration: none;\n\n    margin-bottom: ", ";\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: ", ";\n\n  .", " {\n    display: block;\n    text-decoration: none;\n\n    margin-bottom: ", ";\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return polished_1.em(theme.grid.gutterWidth);
}, linkClass, function (_a) {
  var theme = _a.theme;
  return polished_1.em(theme.grid.gutterWidth);
});
var Item = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var Picture = styled_components_1["default"](MediaManagerImage_1["default"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  min-width: ", ";\n  max-width: ", ";\n  margin-right: ", ";\n"], ["\n  min-width: ", ";\n  max-width: ", ";\n  margin-right: ", ";\n"])), polished_1.em(87), polished_1.em(87), function (_a) {
  var theme = _a.theme;
  return polished_1.em(theme.grid.gutterWidth);
});
var Info = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  line-height: 1.3;\n"], ["\n  line-height: 1.3;\n"])));
var Title = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: #fff;\n  font-weight: bold;\n"], ["\n  color: #fff;\n  font-weight: bold;\n"])));
var Date = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n"], ["\n  font-size: ", ";\n  color: ", ";\n"])), polished_1.em(12), function (_a) {
  var theme = _a.theme;
  return theme.color.fadedText;
});

var C = function C(_a) {
  var items = _a.items,
      renderLink = _a.renderLink,
      className = _a.className;

  var renderItem = function renderItem(item, idx) {
    return renderLink({
      type: utilities_1.WIDGET_LINK_TYPE.ARTICLE_DETAIL,
      payload: item,
      linkProps: {
        className: linkClass,
        key: item._id,
        children: react_1["default"].createElement(Item, null, react_1["default"].createElement(Picture, {
          picture: item.picture,
          naturalWidth: 87,
          naturalHeight: 0,
          height: "100%",
          script: "media"
        }), react_1["default"].createElement(Info, null, react_1["default"].createElement(Title, null, item.name), react_1["default"].createElement(Date, null, utilities_1.getArticleMeta(item))))
      }
    });
  };

  return react_1["default"].createElement(Wrapper, {
    className: className
  }, items.map(renderItem));
};

C.propTypes = {
  className: prop_types_1["default"].string,
  renderLink: prop_types_1["default"].func.isRequired
};
C.defaultProps = {
  className: null
};
exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;